import Api, { baseUrl, baseFile } from '../serviceAPI';
import helper from './helper';

export default {
    External: {
        BaseFile: baseFile,
        DownloadFileBase64: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.post(`${baseUrl}/downloadFileBase64`, payload, { headers: helper.GEN.toHeader(header) } )
                    resolve(res.data);
                } catch (err) {
                    resolve();
                }
            });
        },
        UploadFile: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.post(`${baseUrl}/uploadFile`, payload, { headers: helper.GEN.toHeader(header) } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    resolve({ res: 'resMOCK', resData: { URL: 'https://static.wikia.nocookie.net/himoto-umaruchan/images/5/55/Umaru_Doma.jpg/revision/latest?cb=20200901193803' } });
                    // reject(err)
                }
            });
        },
        DownloadFile: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.post(`${baseFile}/open-base64/Resume`, payload, { headers: helper.GEN.toHeader(header) } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
    },
    Dropdown: {
        DDPosition: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.get(`${baseUrl}/api/v1/nur/config/searchDdlPosition`, { headers: helper.GEN.toHeader(header), params: payload } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
    },
    Profile: {
        SearchConfig: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.get(`${baseUrl}/api/v1/nur/config/searchConfig`, { headers: helper.GEN.toHeader(header), params: payload } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
        SearchId: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.get(`${baseUrl}/api/v1/nur/member/searchId`, { headers: helper.GEN.toHeader(header), params: payload } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
        SearchMember: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.get(`${baseUrl}/api/v1/nur/member/searchMember`, { headers: helper.GEN.toHeader(header), params: payload } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
        SearchTaxCertificate: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.get(`${baseUrl}/api/v1/nur/member/searchWithholdingTaxCertificate`, { headers: helper.GEN.toHeader(header), params: payload } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
        UpdateMember: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.post(`${baseUrl}/api/v1/nur/member/updateMember`, payload, { headers: helper.GEN.toHeader(header) } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
        CreateRegister: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.post(`${baseUrl}/api/v1/nur/member/createRegister`, payload, { headers: helper.GEN.toHeader(header) } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
        CreateMemberPayment: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.post(`${baseUrl}/api/v1/nur/member/createMemberPayment`, payload, { headers: helper.GEN.toHeader(header) } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
    },
    BookShift: {
        SearchMySchedule: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.get(`${baseUrl}/api/v1/nur/schedule/searchMySchedule`, { headers: helper.GEN.toHeader(header), params: payload } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
        SearchHospital: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.get(`${baseUrl}/api/v1/nur/hospital/searchHospital`, { headers: helper.GEN.toHeader(header), params: payload } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
        SearchWard: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.get(`${baseUrl}/api/v1/nur/hospital/searchWard`, { headers: helper.GEN.toHeader(header), params: payload } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
        SearchWorkShiftSchedule: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.get(`${baseUrl}/api/v1/nur/schedule/searchWorkShiftSchedule`, { headers: helper.GEN.toHeader(header), params: payload } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
        CreateBookingWork: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.post(`${baseUrl}/api/v1/nur/schedule/createBookingWork`, payload, { headers: helper.GEN.toHeader(header) } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
    },
    CheckIn: {
        SearchTimeRecord: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.get(`${baseUrl}/api/v1/nur/timeRecord/searchTimeRecord`, { headers: helper.GEN.toHeader(header), params: payload } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
        SearchTimeRecordHistories: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.get(`${baseUrl}/api/v1/nur/timeRecord/searchTimeRecordHistories`, { headers: helper.GEN.toHeader(header), params: payload } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
        CreateTimeRecord: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.post(`${baseUrl}/api/v1/nur/timeRecord/createTimeRecord`, payload, { headers: helper.GEN.toHeader(header) } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
        CreateEndorseTime : (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.post(`${baseUrl}/api/v1/nur/timeRecord/createEndorseTime`, payload, { headers: helper.GEN.toHeader(header) } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
    },
    CashWork: {
        SearchAnnouce: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.get(`${baseUrl}/api/v1/nur/hospital/searchAnnouce`, { headers: helper.GEN.toHeader(header), params: payload } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
        SearchAnnouceView: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    let res = await Api.get(`${baseUrl}/api/v1/nur/hospital/searchAnnouce`, { headers: helper.GEN.toHeader(header), params: payload } )
                    // res.data = res.data [].f
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
    },
    Collect: {
        SearchRewardHistories : (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.get(`${baseUrl}/api/v1/nur/reward/searchRewardHistories`, { headers: helper.GEN.toHeader(header), params: payload } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
        CreateGoenka: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.post(`${baseUrl}/api/v1/nur/reward/createGoenka`, payload, { headers: helper.GEN.toHeader(header) } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
    },
    Iframe: {
        CreateImportPoint: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.post(`${baseUrl}/api/v1/nur/reward/createImportPoint`, payload, { headers: helper.GEN.toHeader(header) } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
        CreateImportSchedule: (payload = {}, header= {}) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Api.post(`${baseUrl}/api/v1/nur/schedule/createImportSchedule`, payload, { headers: helper.GEN.toHeader(header) } )
                    resolve({ res: res, resData: res.data });
                } catch (err) {
                    reject(err)
                }
            });
        },
    }
}
